import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import MessageWithButton from 'Layout/Messages/MessageWithButton';
import loader from 'assets/images/loader.gif';
import withStep from './StepContext/withStep';

class StepFinish extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        generateDiet: PropTypes.func.isRequired,
        generateDietError: PropTypes.bool.isRequired,
        prevStep: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.generateDiet();
    }

    render() {
        const { t, generateDietError, prevStep } = this.props;

        return (
            <div className="full-screen3">
                <div className="text-center my-auto">
                    {generateDietError ? (
                        <MessageWithButton
                            color="danger"
                            renderButton={() => (
                                <Button color="primary" onClick={prevStep()}>
                                    {this.props.t('Try again')}
                                </Button>
                            )}
                        >
                            <h2 className="alert-heading">
                                {this.props.t('Something went wrong')}
                            </h2>
                            <p>
                                {this.props.t(
                                    'Incident has been reported and we will work to solve it'
                                )}
                            </p>
                        </MessageWithButton>
                    ) : (
                        <React.Fragment>
                            <p>{t('diet-settings/finish')}</p>
                            <img
                                src={loader}
                                className="img-fluid"
                                style={{ maxWidth: '150px' }}
                                alt=""
                            />
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export default withStep(withLocale(StepFinish));
